<h2 mat-dialog-title>Share View</h2>

<mat-dialog-content>
  @if (showEmptyMessage) {
    <div class="empty-message">
      <mat-icon>info</mat-icon>
      <p>Either no saved views to share or you do not have access to other users</p>
    </div>
  } @else {
    <div class="share-view-container">
      <!-- User Selection -->
      <div class="selection-section">
        <h3>Select User to Share With</h3>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Search for user</mat-label>
          <input
            type="text"
            matInput
            [(ngModel)]="userSearchText"
            (ngModelChange)="filterUsers()"
            [matAutocomplete]="autoUsers"
            placeholder="Type name or email..."
          />
          <mat-icon matPrefix>person</mat-icon>
          <mat-autocomplete
            #autoUsers="matAutocomplete"
            [displayWith]="displayUserFn"
            (optionSelected)="onUserSelected($event.option.value)"
          >
            @for (user of filteredUsers; track user.email) {
              <mat-option [value]="user">
                <div class="user-option">
                  <span class="user-name">{{ user.friendlyName || user.email }}</span>
                  @if (user.email) {
                    <span class="user-email">{{ user.email }}</span>
                  }
                </div>
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        @if (selectedUser) {
          <div class="selected-item">
            <mat-icon>check_circle</mat-icon>
            <span>Selected: {{ selectedUser.friendlyName || selectedUser.email }}</span>
          </div>
        }
      </div>

      <!-- View Selection -->
      <div class="selection-section">
        <h3>Select View to Share</h3>
        @if (data.savedViews && data.savedViews.length > 0) {
          <mat-list class="views-list">
            @for (view of data.savedViews; track view.name) {
              <mat-list-item
                [class.selected]="selectedView?.name === view.name"
                (click)="selectView(view)"
              >
                <button mat-button class="view-button">
                  <mat-icon>
                    {{ selectedView?.name === view.name ? 'radio_button_checked' : 'radio_button_unchecked' }}
                  </mat-icon>
                  <span class="view-name">{{ view.name || 'Unnamed View' }}</span>
                </button>
              </mat-list-item>
            }
          </mat-list>
        } @else {
          <p class="no-views">No saved views available</p>
        }
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="isSharing">
    Cancel
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="shareViewNow()"
    [disabled]="!canShare()"
  >
    @if (isSharing) {
      <span>Sharing...</span>
    } @else {
      <span>Share View</span>
    }
  </button>
</mat-dialog-actions>
